// src/App.js
import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./styles/App.css";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Services from "./components/Services";
import WhyChooseUs from "./components/WhyChooseUs";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Products from "./components/Products";
import Blog from "./components/Blog";
import Gallery from "./components/Gallery";
import Recognitions from "./components/Recognitions";


import AOS from "aos";
import "aos/dist/aos.css";

const App = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      offset: 80,
      easing: "ease-in-out",
      once: false,
    });
  }, []);

  return (
    <Router>
      <div className="app-root">
        <Navbar />

        <Routes>
          {/* === Home Page === */}
          <Route
            path="/"
            element={
              <>
                <main>
                  <Hero />
                  <About />
                  <Blog />
                  <Products />
                  <Services />
                  <WhyChooseUs />
                  <Contact />
                </main>
                <Footer />
              </>
            }
          />

          {/* === Gallery Page === */}
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/recognitions" element={<Recognitions />} />


        </Routes>
      </div>
    </Router>
  );
};

export default App;